
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api'
import { SettingsContext } from '@/utilities/settings-context'
import { DateFormat } from '@/filters/date-filter';
import axios from 'axios'
import type { Params, Data, UserQuery, HistoryValueResponse, HistoryValue, CompanyResponse, PostingResponse } from './admin-partial-sponsoring-types';

export default defineComponent({
  setup(_, context)
  {
    const params = computed<Params>(() => ({
      id: context.root.$route.params.id ? +context.root.$route.params.id : null,
      companyId: +context.root.$route.params.company,
    }));

    const data = reactive<Data>({
      company: [],
      posting: null,
    });

    const query = reactive<UserQuery>({
      from: null,
      to: null,
    });

    const mapResponseToHistoryItem = (historyResponse: HistoryValueResponse): HistoryValue => ({
      manuallySet: historyResponse.manuallySet,
      points: historyResponse.points,
      periodStart: new Date(historyResponse.periodStart),
      periodEnd: historyResponse.periodEnd ? new Date(historyResponse.periodEnd) : null,
    });

    const getCompanyData = async () =>
    {
      const response = await axios.get<CompanyResponse[]>(`${SettingsContext.getApiUrl('getPartialSponsoringCompanyJobsPointsHistory')}/${params.value.companyId}`, {
        params: {
          from: query.from,
          to: query.to,
        }
      })

      data.company = response.data.map((item) => ({
        title: item.title,
        postingId: item.postingId,
        history: item.history.map(mapResponseToHistoryItem),
      }));
    };

    const getPostingData = async () =>
    {
      const response = await axios.get<PostingResponse>(`${SettingsContext.getApiUrl('getPartialSponsoringJobPointsHistory')}/${params.value.id}`, {
        params: {
          from: query.from,
          to: query.to,
        }
      });

      data.posting = {
        title: response.data.title,
        history: response.data.history.map(mapResponseToHistoryItem),
      }

      console.log(data.posting);
    };

    const getData = async () =>
    {
      const { id } = params.value;

      if (id === null)
      {
        data.posting = null;
        await getCompanyData();
      } else if (id)
      {
        data.company = [];
        await getPostingData();
      }
    }

    onMounted(async () =>
    {
      await getData();
    });

    return {
      params,
      query,
      data,
      DateFormat
    }
  },
})